import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';

import { CustomerFacade, NotificationFacade } from '@ridango/components';
import { BaseComponent } from '@ridango/core';

import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    templateUrl: './email-verification-page.component.html',
    styleUrls: ['./email-verification-page.component.scss']
})
export class EmailVerificationPageComponent extends BaseComponent implements OnInit, OnDestroy {
    isEmailChanged$: Observable<boolean> = this.customerFacade.isEmailChanged$;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private customerFacade: CustomerFacade,
        private translate: TranslateService,
        private notification: NotificationFacade
    ) {
        super();
    }

    ngOnInit() {
        this.route.params.pipe(takeUntil(this.componentDestroyed$)).subscribe((params) => {
            if (params && params.token) {
                this.customerFacade.saveCustomerNewEmail(params.token);
            } else {
                this.notification.error(this.translate.instant('LOCAL_NO_VERIFICATION_TOKEN'), {
                    showAfterRouteChange: true
                });
                this.router.navigate([this.translate.currentLang, 'account', 'profile']);
            }
        });

        this.customerFacade.isEmailChanged$.pipe(takeUntil(this.componentDestroyed$)).subscribe((isEmailChanged) => {
            if (isEmailChanged) {
                this.notification.success(this.translate.instant('LOCAL_EMAIL_SUCCESSFULLY_CHANGED'), {
                    showAfterRouteChange: true
                });
                this.router.navigate([this.translate.currentLang, 'account', 'profile']);
            }
        });

        this.customerFacade.error$.pipe(takeUntil(this.componentDestroyed$)).subscribe((error) => {
            if (error) {
                this.handleError(error);
                this.router.navigate([this.translate.currentLang, 'account', 'profile']);
            }
        });
    }

    handleError(e: any) {
        if (e.error.error) {
            this.notification.error(this.translate.instant(e.error.error), { showAfterRouteChange: true });
        } else {
            this.notification.error(this.translate.instant(e.error), { showAfterRouteChange: true });
        }
    }
}
